import {
    GET_EVALUATIONS, // <--- AJOUTER CECI
    GET_EVALUATIONS_FAIL,
    GET_EVALUATIONS_SUCCESS,

    ADD_EVALUATION_SUCCESS,
    ADD_EVALUATION_FAIL,
    UPDATE_EVALUATION_SUCCESS,
    UPDATE_EVALUATION_FAIL,
    DELETE_EVALUATION_SUCCESS,
    DELETE_EVALUATION_FAIL,

    // AVERAGE
    GET_AVERAGE_BY_EVALUATION,
    GET_AVERAGE_BY_EVALUATION_SUCCESS,
    GET_AVERAGE_BY_EVALUATION_FAIL,

} from "./actionTypes";

const INIT_STATE = {
    evaluations: [],
    annualDeliberation: null, // <--- Doit être présent ici
    error: null,
    loading: false,
    lastActionSuccess: false,
    averageData: [],
    loadingAverage: false,
};

const evaluationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // ============================================================
        // AJOUT : Gestion de l'état de chargement initial
        // ============================================================
        case GET_EVALUATIONS:
            return {
                ...state,
                loading: true,
                evaluations: [], // On vide pour éviter l'affichage de données obsolètes (flash)
                error: null
            };
            
        // Récupération des evaluations
        /*case GET_EVALUATIONS_SUCCESS:
            return {
                ...state,
                evaluations: action.payload.evaluations, // tableau d'objets evaluation
                loading: false,
                error: null
            };
        */
        case GET_EVALUATIONS_SUCCESS:
            return {
                ...state,
                evaluations: action.payload.evaluations || action.payload, // Gère les deux formats de réponse
                annualDeliberation: action.payload.annual_deliberation || null,
                loading: false,
            };

        case GET_EVALUATIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une evaluatione
        case ADD_EVALUATION_SUCCESS:
            return {
                ...state,
                evaluations: [action.payload, ...state.evaluations], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true
            };

        case ADD_EVALUATION_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Mise à jour d'une evaluatione
        case UPDATE_EVALUATION_SUCCESS:
            return {
                ...state,
                evaluations: state.evaluations.map(evaluation =>
                    evaluation.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet evaluation
                        : evaluation
                ),
                error: null,
                lastActionSuccess: true
            };

        case UPDATE_EVALUATION_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Suppression d'une evaluatione
        case DELETE_EVALUATION_SUCCESS:
            return {
                ...state,
                evaluations: state.evaluations.filter(
                    evaluation => evaluation.id !== action.payload
                ),
                error: null
            };


        case DELETE_EVALUATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };

        case GET_AVERAGE_BY_EVALUATION:
            return { ...state, loadingAverage: true, error: null };
        case GET_AVERAGE_BY_EVALUATION_SUCCESS:
            return { ...state, loadingAverage: false, averageData: action.payload };
        case GET_AVERAGE_BY_EVALUATION_FAIL:
            return { ...state, loadingAverage: false, error: action.payload };

        default:
            return state;
    }
};

export default evaluationReducer;
